import { render, staticRenderFns } from "./IndicatorPenaltyPoints.vue?vue&type=template&id=41b36637&scoped=true&"
import script from "./IndicatorPenaltyPoints.vue?vue&type=script&lang=js&"
export * from "./IndicatorPenaltyPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b36637",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
